import { isControl } from '@jsonforms/core';
export const optionIs = (optionName) => (uischema) => {
    if (!uischema || !isControl(uischema)) {
        return false;
    }
    const options = uischema.options;
    const result = !!(options && options[optionName]);
    return result;
};
